/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 var selected_tags = [];

 $(document).ready(function () {

  setTimeout(() => {    
    $('[data-action="toggle-tab"]:not(.is-active)').trigger('click');
  }, 1000);
  setTimeout(() => {    
    $('[data-action="toggle-tab"]:not(.is-active)').trigger('click');
  }, 200);

  setTimeout(function(){
    if($(".ProductList-Header-Secondary").length) {
      var top_of_element = $(".ProductList-Header-Secondary").offset().top;
      var bottom_of_element = $(".ProductList-Header-Secondary").offset().top + $(".ProductList-Header-Secondary").outerHeight();
      var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
      var top_of_screen = $(window).scrollTop();
    
      console.log(top_of_element, bottom_of_element,top_of_screen, bottom_of_screen);
    
      if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
            
      } else {
        $(".Sticky-Header").show();
      }
    }

  }, 500);
   



   $(document).on('click', '.default-product-add-btn', function (e) {
     e.preventDefault();
     var variant_id = $(this).data('variant-id');
     let formData = {
       'items': [{
         'id': variant_id,
         'quantity': 1
       }]
     };
 
     fetch('/cart/add.js', {
       method: 'POST',
       headers: {
         'Content-Type': 'application/json'
       },
       body: JSON.stringify(formData)
     })
       .then(response => {
         $.get("/cart?view=drawer", function (data) {
           var newCartEl = $(data);
           $('#sidebar-cart').replaceWith(newCartEl);
           $('#sidebar-cart').attr("aria-hidden", false);
         });
         console.log(response.json())
       })
       .catch((error) => {
         console.error('Error:', error);
       });
   });
 
   $(".expandable-attribute-header").on('click', function () {
     if ($(this).find('.Collapsible__Plus').hasClass('without-after-element')) {
       $(this).find('.Collapsible__Plus').removeClass('without-after-element');
     } else {
       $(this).find('.Collapsible__Plus').addClass('without-after-element');
     }
     $(this).closest('.expandable-attribute-item').find('.expandable-item').slideToggle();
   });
 
   $(document).on('click', '.HorizontalList_Second_Item', function () {
     console.log($(this).attr("class"));
     $(this).closest('.SizeSwatchList').find('.check-box-icon').each(function () {
       if (!$(this).hasClass('check-box-icon-hide')) {
         $(this).addClass('check-box-icon-hide')
       }
     });
     $(this).find('.check-box-icon').removeClass('check-box-icon-hide');
   });
 
   $(document).on('click', '.product-add-on', function (e) {
     e.preventDefault();
     //console.log($(this).text())
     if ($(this).text() == '+ Add') {
       var addon_id = $(this).data('variant-id');
       let formData = {
         'items': [{
           'id': addon_id,
           'quantity': 1
         }]
       };
 
       fetch('/cart/add.js', {
         method: 'POST',
         headers: {
           'Content-Type': 'application/json'
         },
         body: JSON.stringify(formData)
       })
         .then(response => {
           location.href = "";
         })
         .catch((error) => {
           console.error('Error:', error);
         });
     }
   });
 
   $(".Filter_item, .ships-checkbox").change(function () {

    if($(this).prop('checked')) {
      $(this).closest('.collection-custom-filter').find('input').prop('checked', false);
      $(this).prop('checked', true);
    }
    
     
     selected_tags = []; //initialize the selected tags list
     $('.Filter_item:checked').each(function () {
       var tag_value = $(this).closest('.Linklist__Item').find('.data-tag-value').data('tag-value');
       if (!selected_tags.includes(tag_value)) {
         selected_tags.push(tag_value)
       }
 
       console.log(selected_tags);
 
     });


 
     if ($(".ships-checkbox:checked").length > 0) {
       if (!selected_tags.includes('shipimmediately')) {
         selected_tags.push('shipimmediately');
       }
     }

     if(selected_tags.length) {
       $('.custom-filter-reset').show();
     } else {
      $('.custom-filter-reset').hide();
     }

    if($(window).width() < 768 ) {
      return;
    }
 
     $('.ProductItem_Cell').each(function () {
       var array_tags = $(this).data('array-tags').split(",");
       let checker = (arr, target) => target.every(v => arr.includes(v));
       if (checker(array_tags, selected_tags)) {
         $(this).show();
       } else {
         $(this).hide();
       }
     });
 
     $('.collection-title').each(function () {
       console.log("products_height_", $(this).next(".products-box").height());
       var productbox_height = $(this).next(".products-box").height();
       if (productbox_height == 0) {
         $(this).hide();
       } else {
         $(this).show();
       }
     });

    //  var collectionTitle;
    //  if($('.Collapsible:nth-child(2) .Filter_item:checked').length) {
    //    collectionTitle = $('.Collapsible:nth-child(2) .Filter_item:checked').next().next().data('tag-value').replace('Collection_', '');
    //  } else {
    //   collectionTitle = $('.Collapsible:nth-child(2) .Linklist__Item:first-child .Filter_item').next().next().data('tag-value').replace('Collection_', '');
    //  }

    //  console.log(collectionTitle);
     

     $("html, body").animate({ scrollTop: $(".collection-title:first-child").offset().top }, "fast");
 
   });

   $('.custom-filter-apply').on('click', function(e){
    selected_tags = []; //initialize the selected tags list
    $('.Filter_item:checked').each(function () {
      var tag_value = $(this).closest('.Linklist__Item').find('.data-tag-value').data('tag-value');
      if (!selected_tags.includes(tag_value)) {
        selected_tags.push(tag_value)
      }

      console.log(selected_tags);

    });



    if ($(".ships-checkbox:checked").length > 0) {
      if (!selected_tags.includes('shipimmediately')) {
        selected_tags.push('shipimmediately');
      }
    }

    $('.ProductItem_Cell').each(function () {
      var array_tags = $(this).data('array-tags').split(",");
      let checker = (arr, target) => target.every(v => arr.includes(v));
      if (checker(array_tags, selected_tags)) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });

    $('.collection-title').each(function () {
      console.log("products_height_", $(this).next(".products-box").height());
      var productbox_height = $(this).next(".products-box").height();
      if (productbox_height == 0) {
        $(this).hide();
      } else {
        $(this).show();
      }
    });

    $('.PageOverlay').trigger('click');
    $("html, body").animate({ scrollTop: 0 }, "slow");
   });

   $('.custom-filter-reset').on('click', function(e){
    $('.Filter_item:checked').each(function () {
      $(this).prop('checked', false);
    });

    $(".ships-checkbox").prop('checked', false);
    $(this).hide();
   })

   var $triggerModal = undefined;
   var $closeButton = undefined;
 
   $(document).on('click', '.trigger-pop-up', function () {
     $triggerModal = $(this).closest(".modal-action-box").find(".pop-up-modal");
     //$closeButton = $(this).closest(".text-icons-actions").find(".close-button")
     $triggerModal.toggleClass("show-pop-up");
   });
   $(document).on('click', '.icon-clickable-box', function () {
     $triggerModal = $(this).closest(".product_bottom_icons_item").find(".pop-up-modal");
     $triggerModal.toggleClass("show-pop-up");
   });
   $(".close-button").click(function () {
     $triggerModal.toggleClass("show-pop-up");
   });
 
   $(window).click(function (e) {
     if (e.target.className.includes("show-pop-up")) {
       $triggerModal.removeClass("show-pop-up");
     }
   });
 
   //
   $(".collection-item-medium").hover(function () {
     var imgurl = $(this).data("hoverimage");
     $(this).css("background-image", "url(" + imgurl + ")");
     $(this).css("background-size", "cover");
     $(this).find(".collection-img").hide();
     $(this).find(".collection-featured-title").hide();
     $(this).find(".collection-featured-link").show();
   }, function () {
     $(this).css("background-image", "");
     $(this).find(".collection-img").show();
     $(this).find(".collection-featured-title").show();
     $(this).find(".collection-featured-link").hide();
   });
 
   $(document).on('click', '.collection-item-small', function () {
     var imgurl = $(this).data("hoverimage");
     location.href = imgurl;
   });
 
   $('.ProductList-Header-Secondary').on('inview', function (event, isInView) {
     if (isInView) {
       $('.Sticky-Header').hide();
       console.log('sticky header hide');
     } else {
       $('.Sticky-Header').show();
       console.log('sticky header show');
     }
   });

   
 
   if($('body').hasClass('template-collection')) {
     window.scrollTo(0, 0);
   }
 
   if($('#ZlistWishlist').length > 0 && $('#ZlistWishlist').html().length == 0) {
     $('#ZlistWishlist').css('margin-top', '-5px');
   }
   if(navigator.platform.match('Mac') !== null) {
     $('body').classList.add("OSX");
   }
 
 });
 
 
 //  $(window).load(function(){
 //   var win = $(this); //this = window
 //   if (win.width() <= 1007) {
 //     $('.ProductMedia--Secondary').appendTo('.Product_Info_Mobile_Second');
 //     $('shopify-payment-terms').appendTo('.Product_Info_Mobile_Second');
 //     $('.shop_pay').css({"opacity":1, "height":'auto'});
 
 //   }
 //  });
 
 //  $(window).on('resize', function(){
 //   var win = $(this); //this = window
 //   if (win.height() >= 820) { /* ... */ }
 //   if (win.width() <= 1007) {
 //     $('.ProductMedia--Secondary').appendTo('.Product_Info_Mobile_Second');
 //     $('shopify-payment-terms').appendTo('.Product_Info_Mobile_Second');
 //   } else {
 //     $('.ProductMedia--Secondary').appendTo('.ProductMedia--Secondary--Parent');
 //     $('shopify-payment-terms').appendTo('.shop_pay');
 //   }
 //  });
 
 $(".Footer-expandable-attribute-header").on('click', function () {
   $(this).closest('.Footer-expandable-attribute-item').find('.Footer-expandable-attribute-context').slideToggle();
 });
 
 
 
 $(document).on('click', '.sidenav_link', function(e){
  e.preventDefault();
  if($(this).attr('href').includes(document.location.pathname )) {
    $('.PageOverlay').trigger('click');
    document.location.href = $(this).attr('href');
  } else {
    document.location.href = $(this).attr('href');
  }
 });

 $(document).on('scroll', function(){
   if($(window).scrollTop() > 0) {
     $('.shopify-section--header').addClass('is-scrolled');
   } else {
    $('.shopify-section--header').removeClass('is-scrolled');
   }
 });